export default __webpack_public_path__ + "static/media/MeeshoLogo.efa6983e.svg";